import { createAsyncThunk } from '@reduxjs/toolkit';
import { ImageDocumentStoreItem, RetrievedDocumentReferenceLink } from '@v2/components/imageHandling/types/types';
import { AppDispatch } from '@store/types';
import { updateImageDocumentInDict } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';
import { updateImageMetadata } from './updateImageMetadata';

interface HandleToggleFavoriteLinkPayload {
  scopeId: number;
  scopeReferenceId: number;
  img: ImageDocumentStoreItem;
}

export const handleToggleFavoriteLink = createAsyncThunk<void, HandleToggleFavoriteLinkPayload, { dispatch: AppDispatch }>(
  'imageHandlingV2/handleToggleFavoriteLink',
  async ({ scopeId, scopeReferenceId, img }, { dispatch }) => {
    if (!img || !img.links) return;

    const prevLinks = img.links;

    // Build updated links array with toggled favorite state (only within same link)
    const newLinks = prevLinks.map((l) => {
      if (l.scopeId === scopeId && l.scopeReferenceId === scopeReferenceId) {
        // Toggle current link
        return { ...l, isFavorite: !l.isFavorite };
      }
      return l;
    }) as RetrievedDocumentReferenceLink[];

    dispatch(updateImageDocumentInDict({ documentId: img.documentId!, updatedImageDocument: { ...img, links: newLinks } }));

    // Build map prev favorite
    const prevFavMap: Record<string, boolean> = {};

    prevLinks.forEach((pl) => {
      prevFavMap[`${pl.scopeId}_${pl.scopeReferenceId}`] = !!pl.isFavorite;
    });

    const backendData = {
      documentId: img.id,
      documentLinks: newLinks.map((l) => ({
        scopeId: l.scopeId,
        scopeReferenceId: l.scopeReferenceId,
        scopeReferenceName: l.scopeReferenceName,
        isFavorite: l.isFavorite,
        isActivated: true, // link exists means active
        isFavoriteChanged: prevFavMap[`${l.scopeId}_${l.scopeReferenceId}`] !== l.isFavorite,
      })),
      documentTags: img?.documentTag ? [img.documentTag] : null,
    };

    dispatch(updateImageMetadata({ data: backendData }));
  }
);
